// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
   firebaseConfig : {
    apiKey: "AIzaSyAxYyLLnFSMBkCmhPOIWplh_2KqTYgdSGQ",
    authDomain: "aicasindia-in.firebaseapp.com",
    projectId: "aicasindia-in",
    storageBucket: "aicasindia-in.appspot.com",
    messagingSenderId: "1042438150205",
    appId: "1:1042438150205:web:ab33e49ee3400fb4d2f254",
    measurementId: "G-E20QWPY677"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
